module.exports = __webpack_public_path__ + "assets/svg/yt_play.svg";